import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Page, Container, Grid } from "@common-ui/ui";
import { Auth } from "aws-amplify";

import { Header } from "../../components";

import { PlacesTreeView } from "./CustomerPlacesTreeView";
import { customerPlaces } from "../../__mocks__";

export const Places = () => {
  let history = useHistory();
  useEffect(() => {
    async function fetchData() {
      try {
        await Auth.currentAuthenticatedUser();
      } catch (error) {
        history && history.push("/sign-in");
      }
    }
    fetchData();
  }, [history]);

  return (
    <Page title="FlukeWorks">
      <Header xl name="Places" history={history} />
      <Container maxWidth="xl" component="main" sx={{ my: 2 }}>
        <Grid container spacing={2}>
          <Grid item md={4}>
            <PlacesTreeView data={customerPlaces} />
          </Grid>
          <Grid md={8}>Place Detail</Grid>
        </Grid>
      </Container>
    </Page>
  );
};
